import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <motion.footer
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="w-full max-w-7xl mt-8 py-6 bg-gray-200 dark:bg-gray-800 text-gray-800 dark:text-gray-200 rounded-lg shadow-md"
    >
      <div className="flex justify-center space-x-6">
        <a
          href="https://x.com/memorychaiin"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary transition-colors duration-200"
        >
          <i className="fab fa-twitter"></i> Twitter
        </a>
        <a
          href="https://discord.com"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary transition-colors duration-200"
        >
          <i className="fab fa-discord"></i> Discord
        </a>
        <a
          href="https://t.me/memorychainnAnnouncements"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary transition-colors duration-200"
        >
          <i className="fab fa-telegram-plane"></i> Telegram
        </a>
      </div>
      <p className="text-center mt-4 text-sm">
        © 2025 MemoryChain. All rights reserved.
      </p>
    </motion.footer>
  );
};

export default Footer;